import featuresStore from "../stores/features/featuresStore";
import { API_HOST, PROXY_HOST } from "./environment";

type EndpointType = "orders" | "invoices" | "features";
export const getBaseUrl = (endpoint: EndpointType): string | undefined => {
   const featureMap: Record<EndpointType, boolean> = {
      orders: featuresStore.apiProxyOrders,
      invoices: featuresStore.apiProxyInvoices,
      features: featuresStore.apiProxyFeatures
   };

   return featureMap[endpoint] ? PROXY_HOST : API_HOST;
};
